import { configureStore } from '@reduxjs/toolkit'
import UserReducer from './Slices/UserSlice'
import ActivePathReducer from './Slices/ActivePathSlice'
import PaginationReducer from './Slices/PaginationSlice'

export default configureStore({
  reducer: {UserReducer,ActivePathReducer, PaginationReducer}
})